import * as React from "react";
import { ChildProps, graphql } from "react-apollo";
import gql from "graphql-tag";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import columnConfigFactory, {
  GqlWithdrawalBatch
} from "./withdrawalBatchColumns";
import { RouteComponentProps, withRouter } from "react-router";

type GqlData = {
  withdrawal_batches: Array<GqlWithdrawalBatch>;
};

type Props = ChildProps<
  {
    name: string;
    createdAtFrom: string;
    createdAtTo: string;
  } & PaginationProps &
    RouteComponentProps,
  GqlData
>;

class WithdrawalBatchesContainer extends React.Component<Props> {
  onSubmit() {
    this.props.data.refetch();
  }

  render() {
    return (
      <BOGraphQLLoader data={this.props.data}>
        <ConfigurableTable
          columnConfigs={columnConfigFactory(this.onSubmit.bind(this))}
          defaultColumns={["Created At", "Id", "Status", "Comment", "Action"]}
          rows={this.props.data.withdrawal_batches || []}
          rowToLink={(batch: GqlWithdrawalBatch) =>
            `/snapscan/settlements/withdrawals/batches/${batch.id}/summary`
          }
          pagination={this.props.pagination}
          name={this.props.name}
          history={this.props.history}
        />
      </BOGraphQLLoader>
    );
  }
}

const batchListGql = gql`
  query WalletWithdrawalBatches(
    $offset: Int
    $limit: Int
    $createdAtFrom: String
    $createdAtTo: String
  ) {
    withdrawal_batches(
      offset: $offset
      limit: $limit
      created_at_from: $createdAtFrom
      created_at_to: $createdAtTo
    ) {
      created_at
      id
      status
      comment
    }
  }
`;

const withBatchesGqlData = graphql<any, Props>(batchListGql, {
  options: props => {
    const {
      createdAtFrom,
      createdAtTo,
      pagination: { offset, limit }
    } = props;

    return {
      fetchPolicy: "network-only",
      variables: {
        createdAtFrom,
        createdAtTo,
        offset,
        limit
      }
    };
  }
});

export default withPagination(
  withRouter(withBatchesGqlData(WithdrawalBatchesContainer))
);
